/* Seelenband Steinquiz: Texte, Fragen und Zuordnung Antwort zu Stein. Hier aendern, wenn Fragen oder Zuordnungen angepasst werden sollen. */
(function () {
  'use strict';

  var R = 'rosenquarz', K = 'korall', M = 'mondstein', T = 'tigerauge', D = 'dalmatiner-jaspis', H = 'haematit',
    A = 'achat', MA = 'malachit', L = 'larvikit', G = 'granat', B = 'regenbogen-bergkristall', LA = 'lapis-lazuli';

  var TEXT = {
    welcomeTitle: '✨ Willkommen zu unserem Edelstein-Quiz! 💎',
    welcomeText: ['Finde in wenigen Klicks den perfekten Edelstein – für dich selbst oder als bedeutungsvolles Geschenk.', '💫 Lass dich inspirieren und entdecke deine persönliche Empfehlung!'],
    start: 'JETZT STARTEN 🚀',
    nameTitle: 'Wie dürfen wir dich nennen?',
    nameText: 'Dein Name hilft uns, dich persönlicher anzusprechen – natürlich bleibt er vertraulich. 💫',
    namePlaceholder: 'Gib deinen Namen ein',
    next: 'Weiter ➝ 🚀',
    back: '← Zurück',
    interlude: 'Die perfekten Edelsteine für deine Bedürfnisse sind...! 🎉',
    showResult: 'RESULTAT ANZEIGEN',
    resultNamed: ', wir sind überzeugt, dass diese Auswahl perfekt zu deinen Bedürfnissen passt!',
    resultAnon: 'Wir sind überzeugt, dass diese Auswahl perfekt zu deinen Bedürfnissen passt!',
    viewProduct: 'PRODUKT ANSEHEN',
    more: 'Mehr erfahren',
    less: 'Weniger Infos',
    restart: 'Quiz erneut starten',
    done: '% Abgeschlossen',
    colorLabel: 'Farbe'
  };

  var WHO = {
    title: 'Schön, dich kennenzulernen! Für wen suchst du einen Edelstein?',
    progress: 13,
    answers: [{ label: '🙋 Für mich selbst', path: 'self' }, { label: '🎁 Für jemand Besonderen', path: 'gift' }]
  };

  var PATHS = {
    self: [
      {
        id: 'q4', progress: 25, title: 'Was ist dir im Moment am wichtigsten?',
        answers: [
          { label: '💖 Mehr Nähe & Harmonie in meinen Beziehungen spüren', stones: [R, K, M] },
          { label: '💪 Selbstbewusster werden & innere Stärke aufbauen', stones: [T, D, H] },
          { label: '🧘‍♀️ Mehr Ruhe & Gelassenheit im Alltag finden', stones: [A, MA, L] },
          { label: '🔥 Mehr Motivation & Antrieb für meine Ziele bekommen', stones: [T, G, H] },
          { label: '🧠 Mehr Klarheit & Fokus für wichtige Entscheidungen gewinnen', stones: [B, LA] },
          { label: '🌿 Mehr Erdung & Stabilität im Leben spüren', stones: [A, L] },
          { label: '💃 Mehr Lebensfreude & Leichtigkeit in meinen Alltag bringen', stones: [D, B, K] }
        ]
      },
      {
        id: 'q5', progress: 38, title: 'Welchen Traum möchtest du dir erfüllen?',
        answers: [
          { label: '🚀 Meine großen Ziele verwirklichen & neue Herausforderungen annehmen', stones: [T, D, G, H] },
          { label: '🔮 Mehr Klarheit für meine Zukunft & meine Entscheidungen treffen', stones: [B, L] },
          { label: '🎉 Leichtigkeit & Freude zurückbringen – das Leben wieder genießen', stones: [MA, K] },
          { label: '🏆 Mutiger werden & mit mehr Selbstvertrauen durchs Leben gehen', stones: [T, H] },
          { label: '🌊 Gelassener werden & stressige Zeiten besser meistern', stones: [A, MA, L, LA] },
          { label: '❤️ Mehr Liebe in mein Leben lassen & tiefe Verbindungen aufbauen', stones: [R, M] },
          { label: '🌍 Mehr innere Balance & ein stabiles Fundament für mich schaffen', stones: [A, L, LA] },
          { label: '❓ Ich bin mir unsicher – wähle einen Stein basierend auf meinen bisherigen Antworten!', stones: [] }
        ]
      },
      {
        id: 'q6', progress: 50, title: 'Welche Farbe gefällt dir bei einem Edelstein am besten?',
        answers: [
          { label: '💗 Rosa / Rot', stones: [R, G, K] },
          { label: '🔵 Blau', stones: [A, LA] },
          { label: '🌿 Grün', stones: [MA] },
          { label: '✨ Gold / Gelb', stones: [T, D] },
          { label: '⚫ Schwarz / Grau', stones: [L, H] },
          { label: '⚪ Weiß / Transparent', stones: [B, M] }
        ]
      }
    ],
    gift: [
      {
        id: 'q7', progress: 63, title: 'Was ist der Anlass?',
        answers: [
          { label: '🎂 Zum Geburtstag eines Herzensmenschen', stones: [R, G, K] },
          { label: '💝 Für die beste Freundin oder Schwester', stones: [MA, B, L, R] },
          { label: '👩‍👩‍👧‍👦 Für Mama oder eine besondere Frau in deinem Leben', stones: [A, L, R] },
          { label: '💖 Für eine Liebeserklärung oder Jahrestag', stones: [R, M] },
          { label: '👶 Für eine werdende Mama oder frischgebackene Eltern', stones: [A, D, L, LA] },
          { label: '🎓 Für Schulstart, Prüfung oder einen neuen Job', stones: [T, D, LA] },
          { label: '🎯 Für einen Neuanfang oder große Ziele', stones: [B, R, H] },
          { label: '🧘‍♀️ Für mehr Entspannung & Wohlbefinden', stones: [A, MA, L] },
          { label: '❓ Anderer Anlass – Lass uns gemeinsam den perfekten Stein finden!', stones: [B] }
        ]
      },
      {
        id: 'q8', progress: 75, title: 'Welche Bedeutung soll das Geschenk haben?',
        answers: [
          { label: '💖 Liebe & tiefe Verbundenheit ausdrücken', stones: [R, K, M] },
          { label: '💪 Mut & Selbstvertrauen stärken', stones: [T, H] },
          { label: '🧘‍♀️ Ruhe & Gelassenheit schenken', stones: [A, MA, L] },
          { label: '🔥 Motivation & Erfolg fördern', stones: [T, G, H] },
          { label: '🧠 Bei Klarheit & Fokus unterstützen', stones: [B, LA] },
          { label: '🌿 Erdung & Stabilität schenken', stones: [A, L] },
          { label: '💃 Lebensfreude & Energie versprühen', stones: [D, B, K] }
        ]
      },
      {
        id: 'q9', progress: 88, title: 'Welche Persönlichkeit hat die beschenkte Person?',
        answers: [
          { label: '🌟 Ein kreativer Freigeist mit viel Fantasie', stones: [A, MA, G] },
          { label: '🎯 Ein ehrgeiziger Mensch, der große Ziele verfolgt', stones: [A, T, L] },
          { label: '☀️ Jemand, der Lebensfreude & positive Energie ausstrahlt', stones: [B, LA] },
          { label: '🧘‍♀️ Ein ruhiger, ausgeglichener Mensch, der Harmonie schätzt', stones: [G, K, H] },
          { label: '💖 Eine liebevolle, fürsorgliche Person, die tiefe Verbindungen sucht', stones: [A, MA] },
          { label: '🛡 Jemand, der Schutz & Sicherheit schätzt', stones: [D, R, M] }
        ]
      }
    ]
  };

  window.SBQ_DATA = { TEXT: TEXT, WHO: WHO, PATHS: PATHS };
})();